export const setAreas = (listArea) => {
    return {
        type: 'LIST_AREA',
        listArea,
    };
};

export const setArea = (area) => {
    return {
        type: 'SET_AREA',
        area
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER',
    };
};
